import { Route, Routes, NavLink, useLocation } from "react-router-dom";
import ProfilePage from "./components/Profile";
import BillingPage from "./components/Billing";

export default function SettingsPage() {
  const location = useLocation();

  const tabs = [
    { name: "Profile", path: "/settings" },
    { name: "Billing", path: "/settings/billing" },
  ];

  return (
    <div className="min-h-screen bg-gallery-50">
      {/* Header */}
      <div className="bg-white border-b border-gallery-200">
        <div className="max-w-4xl mx-auto px-6 pt-12 pb-0">
          <p className="text-xs font-medium uppercase tracking-wider text-gallery-500 mb-3">
            Account
          </p>
          <h1 className="font-display text-display-sm text-gallery-900 mb-6">
            Settings
          </h1>

          {/* Tabs */}
          <nav className="flex gap-8">
            {tabs.map((tab) => {
              const isActive = location.pathname === tab.path;
              return (
                <NavLink
                  key={tab.path}
                  to={tab.path}
                  className={`pb-4 text-sm font-medium border-b-2 transition-colors ${
                    isActive
                      ? "border-gallery-900 text-gallery-900"
                      : "border-transparent text-gallery-500 hover:text-gallery-700 hover:border-gallery-300"
                  }`}
                >
                  {tab.name}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-10">
        <Routes>
          <Route index element={<ProfilePage />} />
          <Route path="billing" element={<BillingPage />} />
        </Routes>
      </div>
    </div>
  );
}
